(() => {
  if (customElements.get('ulike-gallery-tools')) return;
  let viewerReady;
  const loadViewer = (src) => {
    if (customElements.get('model-viewer')) return Promise.resolve();
    if (!viewerReady) viewerReady = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.type = 'module';
      script.src = src;
      script.onload = () => customElements.whenDefined('model-viewer').then(resolve);
      script.onerror = () => { viewerReady = null; script.remove(); reject(new Error('Model viewer unavailable')); };
      document.head.append(script);
    });
    return viewerReady;
  };
  class GalleryTools extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.models = JSON.parse(this.querySelector('[data-models]').textContent);
      this.form = document.getElementById(this.dataset.form);
      this.button = this.querySelector('[data-model-open]');
      this.dialog = this.querySelector('dialog');
      this.status = this.querySelector('[data-model-status]');
      this.stage = this.querySelector('[data-model-stage]');
      this.update(this.form?.querySelector('[name="id"]')?.value || Object.keys(this.models)[0]);
      this.form?.addEventListener('variant:change', e => this.update(e.detail.variant?.id), options);
      this.button.addEventListener('click', () => this.openModel(), options);
      this.querySelector('[data-model-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', e => { if (e.target === this.dialog) this.dialog.close(); }, options);
      this.dialog.addEventListener('close', () => { this.stage.replaceChildren(); this.button.focus(); }, options);
      const share = this.querySelector('details');
      document.addEventListener('click', e => { if (!share.contains(e.target)) share.open = false; }, options);
      this.addEventListener('keydown', e => { if (e.key === 'Escape') share.open = false; }, options);
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; this.dialog?.close(); }
    update(id) {
      const url = this.models[id] || '';
      this.url = /^(https:\/\/|\/\/)/.test(url) ? url : '';
      this.button.hidden = !this.url;
      if (this.dialog.open) this.dialog.close();
    }
    async openModel() {
      if (!this.url) return;
      const url = this.url;
      this.dialog.showModal();
      this.status.textContent = this.status.dataset.loading;
      this.stage.replaceChildren();
      try {
        await loadViewer(this.dataset.viewerSrc);
        if (!this.isConnected || !this.dialog.open || this.url !== url) return;
        const viewer = document.createElement('model-viewer');
        viewer.setAttribute('camera-controls', '');
        viewer.setAttribute('camera-orbit', '180deg 90deg 0');
        viewer.setAttribute('exposure', '1.45');
        viewer.setAttribute('alt', this.dataset.title);
        viewer.addEventListener('load', () => { this.status.textContent = ''; });
        viewer.addEventListener('error', () => { this.status.textContent = this.status.dataset.error; });
        viewer.src = url;
        this.stage.append(viewer);
      } catch { this.status.textContent = this.status.dataset.error; }
    }
  }
  customElements.define('ulike-gallery-tools', GalleryTools);
})();
